/* ============================================================================
   AdminLayout — casca única de todas as páginas do painel.
   Centraliza: guarda de admin, sidenav, logout, toast e confirm.
   Isso elimina a duplicação que existia página a página.
   ============================================================================ */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidenav from './Sidenav';
import { ToastHost } from './Toast';
import { ConfirmHost } from './Modal';
import { isAdmin, clearSession } from '../lib/auth';
import { IconDashboard, IconCourses, IconPlans, IconGoals, IconProfile } from './icons';
import '../theme.css';

const ADMIN_NAV = [
  { icon: IconDashboard, label: 'Dashboard', path: '/treinamentos/manager/dashboard' },
  { icon: IconCourses, label: 'Cursos', path: '/treinamentos/manager/courses' },
  { icon: IconPlans, label: 'Planos', path: '/treinamentos/manager/plans' },
  { icon: IconGoals, label: 'Metas', path: '/treinamentos/manager/goals' },
  { icon: IconProfile, label: 'Perfil', path: '/treinamentos/manager/profile' },
];

export default function AdminLayout({ children, narrow = false }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAdmin()) navigate('/treinamentos/manager', { replace: true });
  }, [navigate]);

  const handleLogout = () => {
    clearSession();
    navigate('/treinamentos/manager', { replace: true });
  };

  return (
    <div className="mg-app">
      <Sidenav items={ADMIN_NAV} brandSub="Admin" homePath="/treinamentos/manager/dashboard" onLogout={handleLogout} />
      <div className="mg-main">
        <div className={`mg-content${narrow ? ' mg-content-narrow' : ''}`}>
          {children}
        </div>
      </div>
      <ToastHost />
      <ConfirmHost />
    </div>
  );
}
